import { headerMenu } from 'components/header/configs';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

interface IProps {
  className?: string;
}

const HeaderMenu: FC<IProps> = ({ className = '' }) => {
  const { t } = useTranslation();

  return (
    <ul className={`flex flex-col p-4 font-bold lg:flex-row lg:space-x-8 lg:border-0 header-menu__wrapper ${className}`}>
      {headerMenu.map((menu, index) => (
        <li
          key={index}
          className='text-center pb-0.5 relative text-hl-jet after:content-[""] after:w-0 after:border-b-2 after:border-b-hl-primary after:absolute after:right-0 after:bottom-0 after:transition-all after:duration-300 after:ease-in-out hover:after:w-full hover:after:left-0 hover:text-hl-primary header-menu__item'
        >
          <NavLink
            to={menu.path}
            className='flex items-center py-2 pr-4 pl-3 transition-all duration-300 ease-in-out lg:p-0 header-menu__item-navlink'
          >
            <span className='header-menu__item-navlink__text'>{t(`${menu.labelCode}`)}</span>
            <i className='lg:hidden header-menu__item-navlink__icon'>
              <svg
                data-slot='icon'
                fill='none'
                strokeWidth='1.5'
                stroke='currentColor'
                viewBox='0 0 24 24'
                xmlns='http://www.w3.org/2000/svg'
                aria-hidden='true'
                className='w-6 h-6'
              >
                <path strokeLinecap='round' strokeLinejoin='round' d='m8.25 4.5 7.5 7.5-7.5 7.5'></path>
              </svg>
            </i>
          </NavLink>
        </li>
      ))}
    </ul>
  );
};

export default HeaderMenu;
